import { render, staticRenderFns } from "./KusVatGroup.vue?vue&type=template&id=4c863970"
import script from "./KusVatGroup.vue?vue&type=script&lang=js"
export * from "./KusVatGroup.vue?vue&type=script&lang=js"
import style0 from "./KusVatGroup.vue?vue&type=style&index=0&id=4c863970&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports